(function () {
    'use strict';

    angular
        .module('app.community')
        .controller('TopicDisplayController', TopicDisplayController);

    TopicDisplayController.$inject = [
        '$scope', '$state', '$stateParams',
        'bootstrap.dialog', 'common', 'dataservice', 'backendHubProxy'
    ];

    function TopicDisplayController($scope, $state, $stateParams, bsDialog, common, dataservice, backendHubProxy) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
        var $q = common.$q;
        
        vm.cancel = cancel;
        vm.title = "OPs Community Conversation";
        
        vm.item = undefined;
        vm.addComment = addComment;
        vm.activeComment = {};
        vm.items = [];
        vm.displayedItems = [].concat(vm.items);
        vm.timeToAgo = timeToAgo;

        $scope.$on('$destroy', function () {
            backendHubProxy.stop();
        });


        activate();

        function activate() {
            backendHubProxy.startListening();
            var promises = [getItem()];
            return common.$q.all(promises).then(function (data) {
                
            }, function (error) { });
        }

        function cancel() {
            backToList();
        }

      
        function backToList() {
            $state.go("community.topics");
        }

        function addComment() {
            if (vm.activeComment && vm.item) {
                if (!vm.activeComment.CommunityTopicUId) {
                    vm.activeComment.CommunityTopicUId = vm.item.UId;
                }

                return dataservice.saveItem("api/Community/SaveComment", vm.activeComment)
                    .then(function (response) {
                        vm.activeComment = {};
                    })
                    .catch(function (error) {
                        logger.error('Error while saving comment, please try again');
                        console.log(error);
                    });
            }
            vm.activeComment = {};
        }

        function timeToAgo(d) {
            var x = moment.utc(d).toDate();
            return moment(x).fromNow();
        }

        function getItem() {
            var val = $stateParams.id;
            
            return dataservice.getItem("api/Community/Details/" + val)
                .then(function (data) {
                    if (data) {
                        vm.item = data.data;
                        
                        vm.items = vm.item.TopicComments;
                        vm.displayedItems = [].concat(vm.items);
                        backendHubProxy.items = vm.items;
                        backendHubProxy.displayedItems = vm.displayedItems;
                        backendHubProxy.topic = vm.item;

                    } else {
                        logger.warning('Could not find item with id = ' + val);
                        $state.go('404');
                    }
                })
                .catch(function (error) {
                    logger.error('Error while getting item with id = ' + val + '; ' + error);
                    $state.go('404');
                });
        }

    }
})();
